import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";

import { Leptin_TableData } from "./Get_Leptin_table";


export default function Dia_Leptin_Variants() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
        <IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
        </IconButton>

        <CustomDialog open={open} onClose={handleClose}

            title='Leptin Signaling Pathway - Variants'

            content={ <Leptin_TableData />}

        />
</>
)}